import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=622db20c&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=622db20c&prod&scoped=true&lang=scss&"
import style1 from "./Index.vue?vue&type=style&index=1&id=622db20c&prod&lang=css&"
import style2 from "./Index.vue?vue&type=style&index=2&id=622db20c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622db20c",
  null
  
)

export default component.exports